import { MustacheTag } from "./mustache-tag.model";
import { MustacheTagTypes } from "./mustache-tag-types.model";

export class MustacheEmptyTag implements MustacheTag {
  type = MustacheTagTypes.empty;
  key: string;
  subKeys: null;
  value: null;
}